import React from 'react';
import { Layout } from 'antd';
import UserProfile from '../Auth/UserProfile';

const { Header, Content } = Layout;

/** Layout reducido para proveedores externos (Smartup): cabecera mínima, sin menú interno. */
const ExternalLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Layout style={{ minHeight: '100vh' }}>
    <Header style={{ padding: '0 24px', background: '#fff', display: 'flex', alignItems: 'center',
      justifyContent: 'space-between', borderBottom: '1px solid #f0f0f0', position: 'sticky', top: 0, zIndex: 1000 }}>
      <span style={{ fontSize: 18, fontWeight: 500 }}>Mejora CU2 · Smartup</span>
      <UserProfile />
    </Header>
    <Content style={{ margin: '24px 16px', padding: 24, minHeight: 280, background: '#fff', borderRadius: 8 }}>
      {children}
    </Content>
  </Layout>
);

export default ExternalLayout;
